import { SidebarProvider } from './ui/sidebar';
import Navbar from './AppNavbar';
import AppSidebar from './AppSidebar';
import { useNavigate } from 'react-router-dom';

interface LayoutProps {
  children: React.ReactNode;
  currentPage: string;
}

export default function Layout({ children, currentPage }: LayoutProps) {
  const navigate = useNavigate();

  return (
    <SidebarProvider>
      <div className="flex h-screen w-full">
        <AppSidebar currentPage={currentPage} />

        {/* Main Content */}
        <div className="flex-1 flex flex-col overflow-hidden">
          <Navbar onHelpClick={() => navigate('/help')} />
          <main className="flex-1 overflow-auto">
            {children}
          </main>
        </div>
      </div>
    </SidebarProvider>
  );
}